<template>
  <div>
    <span class="pr-3">
      <base-icon name="filter" :height="18" :strokeWidth="2"></base-icon>Filters
    </span>
    <label class="container" @click="all()">
      All
      <input type="radio" checked="checked" name="radio">
      <span class="checkmark"></span>
    </label>
    <label class="container" @click="filterSeen(true)">
      Seen
      <input type="radio" name="radio">
      <span class="checkmark"></span>
    </label>
    <label class="container" @click="filterSeen(false)">
      Unseen
      <input type="radio" name="radio">
      <span class="checkmark"></span>
    </label>
    <label class="container" @click="filterScore(true)">
      Scored
      <input type="radio" name="radio">
      <span class="checkmark"></span>
    </label>
    <label class="container" @click="filterScore(false)">
      Unscored
      <input type="radio" name="radio">
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
import NProgress from 'nprogress'
export default {
  methods: {
    filterSeen(trueFalse) {
      console.log('filterSeen')
      this.$store.dispatch('judging/filterSeen', trueFalse)
    },
    all() {
      NProgress.start()
      this.$store
        .dispatch('judging/getEntries')
        .then(() => NProgress.done())
        .catch(() => {
          NProgress.done() // <-- if errors out stop the progress bar
        })
    },
    filterScore(trueFalse) {
      console.log('filterSeen')
      this.$store.dispatch('judging/filterScored', trueFalse)
    }
  }
}
</script>

<style scoped lang="scss">
/* The container */
label.container {
  display: inline;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 1em;
  color: black;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Hide the browser's default radio button */
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
}
/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
label.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
label.container input:checked ~ .checkmark {
  background-color: black;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
label.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
label.container .checkmark:after {
  top: 7px;
  left: 7px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
</style>
